<div class="account-pages mt-5 mb-5">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="text-center">
          <a href="/" class="mb-4 d-block auth-logo">
            <img src="assets/images/KASHPOS.png" alt="" class="logo logo-dark tamaños">
            <img src="assets/images/KASHPOS.png" alt=""
              class="logo logo-light tamaños">
          </a>
        </div>
      </div>
    </div>
    <div class="row align-items-center justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden background-login">

          <div class="card-body p-4" style="background-color: #000 !important;">
            <div class="text-center mt-2">
              <h5 class=" greens">Restaurar contraseña</h5>
              <p class="text-muted text-white">Introduce tu correo eletrónico para buscar tu cuenta.</p>
            </div>
            <div class="p-2 mt-4">
              <div class="alert alert-info text-center mb-4" role="alert">
                ¡Ingresa tu correo y te enviaremos las instrucciones!
              </div>
              <form class="kt-form" [formGroup]="forgotPasswordForm" autocomplete="off">
                <div class="mb-3">
                  <label for="email" class="text-white">Email: </label> <!-- Cambiado de Correo a Email -->
                  <input type="email" name="email" formControlName="email" autocomplete="off" class="form-control" placeholder="Correo Electrónico" id="exampleInputEmail1" >
                  <div *ngIf="isControlHasError('email','required')">
                    <small class="text-danger">Campo requerido</small>
                  </div>
                  <div *ngIf="isControlHasError('email','email')">
                    <small class="text-danger">Este no es un correo valido</small>
                  </div>
                  <div *ngIf="isControlHasError('email','minLength')">
                    <small class="text-danger">{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</small>
                  </div>
                  <div *ngIf="isControlHasError('email','maxLength')">
                    <small class="text-danger">{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</small>
                  </div>
                </div>
                <div [@fadeInUp] *ngIf="disableLabel" class="alert alert-success text-center mb-4" role="alert">
                  En breve te llegará un correo con las instrucciones para restaurar tu contraseña.
                </div>
                
                <div class="mt-3 text-end" style="display: flex; justify-content: end;">
                  <!-- <button class="btn cancel w-sm waves-effect waves-light" (click)="login()" *ngIf="showButtonLogin" type="submit"><i *ngIf="!loadIndicatorVisible" class="fa fa-arrow-left"></i>&nbsp;&nbsp;Volver</button> -->
                  <button (click)="submit()" [disabled]="forgotPasswordForm.invalid || loadIndicatorVisible" class="btn blueButton w-sm waves-effect waves-light" type="submit" style="margin-left: 15px; width: 40%;">
                    <dx-load-indicator *ngIf="loadIndicatorVisible" id="small-indicator" height="20" width="20"></dx-load-indicator><i *ngIf="!loadIndicatorVisible" class="fa fa-paper-plane"></i>&nbsp;&nbsp;{{buttonText}}
                  </button>
                </div>
                <div class="mt-4 text-center">
                  <p class="mb-0 text-white">¿La recuerdas? <a href="/#/login" class="fw-medium  greens">
                      Iniciar Sesión </a></p>
                </div>
              </form>
              
            </div>

          </div>
          
        </div>
        <div class="mt-3 text-center text-white">
          <p>Copyright 2024 © TECSA All rights reserved.</p>
          <!-- <p>© {{year}} Minible. Crafted with <i class="mdi mdi-heart text-danger"></i> by Themesbrand</p> -->
        </div>


      </div>
    </div>
  </div>

  <!-- end container -->
</div>
<!-- end page -->